import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import useMediaQuery from '@mui/material/useMediaQuery'
import Box from '@mui/system/Box'
import DashboardContainer from 'components/smart/dashboard-container/DashboardContainer'
import Typography from '@mui/material/Typography'
import ChevronRight from '@mui/icons-material/ChevronRight'
import AddIcon from '@mui/icons-material/Add'
import ActionNewReportButton from './ActionNewReportButton'
import AdxTabsBadge from 'components/reusable/tab/AdxTabsBadge'
import AdxTabsPanel from 'components/reusable/tab/AdxTabsPanel'
import UnsubmittedReportTable from '../components/table/UnsubmittedReportTable'
import WaitingApprovalReportTable from '../components/table/WaitingApprovalReportTable'
import CompletedReportTable from '../components/table/CompletedReportTable'
import ReimbursementReportTable from '../components/table/ReimbursementReportTable'
import AdxButton from 'components/custom/AdxButton'

const AllReports = () => {
  const isLarge = useMediaQuery((theme) => theme.breakpoints.up('lg'))
  const navigate = useNavigate()
  const { state } = useLocation()
  const handleBack = () => {
    navigate('/app/claim')
  }

  return (
    <DashboardContainer
      headerTitle={
        <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
          <Typography onClick={handleBack} sx={{ cursor: 'pointer', color: 'alternate.main' }}>
            Claim
          </Typography>
          <ChevronRight sx={{ color: 'light-gray-text.main' }} />
          <Box>My Claim Reports</Box>
        </Box>
      }
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center', width: 1 }}>
          <ActionNewReportButton clickable>
            <Box sx={{ width: 1, display: 'flex', justifyContent: 'end' }}>
              <AdxButton
                sx={{
                  display: 'flex',
                  gap: 1,
                  width: { xs: 1, md: 'fit-content' },
                }}
              >
                <AddIcon />
                <Typography variant="body1">Add Expense</Typography>
              </AdxButton>
            </Box>
          </ActionNewReportButton>
        </Box>
        <Box
          sx={{
            bgcolor: 'white.main',
            border: 1,
            borderColor: 'gray-line.main',
            borderRadius: '4.5px',
          }}
        >
          <AdxTabsBadge
            initialValue={state && state.initialTabsValue ? state.initialTabsValue : 0}
            scrollButtons={false}
          >
            <AdxTabsPanel label="Draft">
              <UnsubmittedReportTable />
            </AdxTabsPanel>
            <AdxTabsPanel label="Awaiting Approval">
              <WaitingApprovalReportTable />
            </AdxTabsPanel>
            <AdxTabsPanel label="Awaiting Reimbursement">
              <ReimbursementReportTable />
            </AdxTabsPanel>
            <AdxTabsPanel label="Approved">
              <CompletedReportTable />
            </AdxTabsPanel>
          </AdxTabsBadge>
        </Box>
      </Box>
    </DashboardContainer>
  )
}

export default AllReports
